<div *transloco="let t" [@toastTrigger]="(toastService.showsToast$ | async) ? 'open' : 'close'"
     [class]="toastService.toastState$ | async">
  <span class="pe-3" [innerHTML]="toastService.toastMessage$ | async">
  </span>
  <a class="close-btn" (click)="dismiss()"><small>{{t('app.common.dismiss')}}</small></a>
</div>
